import partners from "./partners";

export const apiPartners = partners;
